/* eslint-disable no-console */
import {Flex, Form, Select, Col, Row, Space} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import TextArea from 'antd/es/input/TextArea';
import React, {Fragment, useState} from 'react';

import {TF} from '../../../constants/Common';
import {statusOptions} from '../../../pages/netZero/utils/commonFunctions';
import usePlatformStore from '../../../store/platformStore/platformStore';
import {formatIndian} from '../../../utils/formatIndian';
import {shouldBlockReadOnly} from '../../../utils/SubscriptionHelper';
import PilComp from '../../DisplayComponent/PilComp';
import {WasteLabel} from '../../Forms/Constants/IP/WasteKeyLabel';
import {EoLTLabel} from '../../Forms/Constants/Products/EotKeyLabel';
import {
  checkerStatusKey,
  checkerStatusLabel
} from '../../Forms/Utils/checkerStatusKeyLabel';
import sumValue from '../../Table/Utils/sumValue';
import {renderFormPreview, renderTimeframeDataUnit} from '../commonFunctions';
import {objTypes} from '../Constants/commonConstants';

import SupplyChainListData from './SupplyChainListData';
import TimeFrameRender from './TimeFrameRender';

const AllDataInfo: React.FC<{
  formData: any;
  formPreview: any[];
}> = ({formData, formPreview}) => {
  const [selectedValue, setSelectedValue] = useState<string>(
    formData[checkerStatusKey.STATUS]
  );
  const FI = useFormInstance();
  const {setFieldsValue} = FI;

  const handleSelectChange = (value: string) => {
    setSelectedValue(value);
    setFieldsValue({
      [checkerStatusKey.STATUS]: value
    });
    if (value !== 'rejected') {
      setFieldsValue({
        [checkerStatusKey.COMMENT]: ''
      });
    }
  };

  let visibleRowIndex = 0;

  return (
    <Flex className="fullInfo">
      {formPreview.map((item) => {
        const value = formData[item.key];
        const interRelatedKey = formData[item?.relatedKey];

        const renderValue = renderFormPreview(value, item, interRelatedKey);

        if (
          formData[item?.relatedKey] === false ||
          (item.relatedKey === 'country' && formData[item?.relatedKey] !== 101)
        ) {
          return null;
        }
        const itemStartIndex = visibleRowIndex;
        if (!item?.hidden) {
          if (item.type === objTypes.timeFrameData) {
            visibleRowIndex += value?.length;
          } else {
            visibleRowIndex += 1;
          }
        }
        const backgroundColor =
          itemStartIndex % 2 === 0 ? '#F3F4F8' : '#ffffff';

        const color = '#d3eec6';

        return (
          <Fragment key={item.key}>
            {!item.hidden && (
              <Row
                key={item.key}
                className="formDataDetails"
                style={{
                  flexDirection: 'row',
                  backgroundColor,
                  borderRadius: '4px'
                }}
              >
                {item.type === 'timeFrameData' ? (
                  item.key === TF ? (
                    value?.map((timeFrame: any, i: number) => {
                      const currentRowIndex = itemStartIndex + i;
                      const backgroundColor =
                        currentRowIndex % 2 === 0 ? '#F3F4F8' : '#ffffff';

                      return (
                        <Fragment key={i}>
                          <Col
                            span={12}
                            className="formProperty"
                            style={{
                              backgroundColor
                            }}
                          >
                            {Array.isArray(item.label)
                              ? item.label?.[i]
                              : item.label}
                            :
                          </Col>
                          <Col
                            span={12}
                            className="formOutput"
                            style={{
                              backgroundColor
                            }}
                          >
                            {renderTimeframeDataUnit(
                              formatIndian(sumValue(timeFrame?.data)),
                              timeFrame?.unit
                            )}
                          </Col>
                        </Fragment>
                      );
                    })
                  ) : (
                    value.map((mainItem: any, i: number) => {
                      const currentRowIndex = itemStartIndex + i;
                      const backgroundColor =
                        currentRowIndex % 2 === 0 ? '#F3F4F8' : '#ffffff';

                      return (
                        <Fragment key={i}>
                          <Col
                            className="formProperty"
                            span={12}
                            style={{
                              backgroundColor
                            }}
                          >
                            {item?.mainLabel?.[i]}
                          </Col>
                          <Col
                            span={12}
                            style={{
                              backgroundColor,
                              display: 'flex',
                              alignItems: 'center',
                              padding: '0px 0px 0px 20px '
                            }}
                          >
                            <TimeFrameRender
                              value={mainItem?.timeFrameData}
                              label={
                                item?.mainLabel?.[i] ===
                                EoLTLabel.disposalKey.notTreated
                                  ? EoLTLabel.notTreated.ProductNotTreated
                                  : item?.mainLabel?.[i] ===
                                      WasteLabel.disposalKey.wasteNotTreated
                                    ? WasteLabel.disposalKey.wasteNotTreated
                                    : item?.label
                              }
                              isChecker={true}
                            />
                          </Col>
                        </Fragment>
                      );
                    })
                  )
                ) : item?.type === objTypes.supplyChainListData ? (
                  <SupplyChainListData value={value} item={item} />
                ) : (
                  <>
                    <Col className="formProperty" span={12}>
                      {item?.label}:
                    </Col>
                    <Col className="formOutput" span={12}>
                      {Array.isArray(renderValue) && item.key !== TF ? (
                        <Space size={[8, 16]} wrap>
                          {renderValue.map((items, index) => {
                            return item?.isGreen ? (
                              <PilComp
                                value={items}
                                color="#d3eec6"
                                style={{padding: '4px 10px'}}
                              />
                            ) : (
                              <div key={index}>{items}</div>
                            );
                          })}
                        </Space>
                      ) : item.type === checkerStatusKey.STATUS ? (
                        <Form.Item
                          name={checkerStatusKey.STATUS}
                          initialValue={formData[checkerStatusKey.STATUS]}
                          style={{marginBottom: 0}}
                        >
                          <Select
                            value={selectedValue}
                            onClick={() => {
                              if (shouldBlockReadOnly()) {
                                usePlatformStore
                                  .getState()
                                  .setOpenOnFreeTrialMessageModel(true);
                              }
                            }}
                            disabled={shouldBlockReadOnly()}
                            onChange={handleSelectChange}
                            placeholder={checkerStatusLabel.STATUS}
                            popupMatchSelectWidth={true}
                            options={statusOptions}
                            className={`statusSelect ${
                              selectedValue === checkerStatusKey.REJECTED
                                ? 'rejected'
                                : selectedValue === checkerStatusKey.ACCEPTED
                                  ? 'accepted'
                                  : 'inReview'
                            }`}
                          />
                        </Form.Item>
                      ) : item.type === 'comment' ? (
                        selectedValue === checkerStatusKey.REJECTED ? (
                          <Flex align="baseline">
                            <Form.Item
                              name={checkerStatusKey.COMMENT}
                              initialValue={
                                formData[checkerStatusKey.COMMENT] ?? 'NA'
                              }
                              rules={[
                                {
                                  required: true,
                                  message: `Please enter ${checkerStatusLabel.COMMENT.toLowerCase()}!`
                                },
                                {
                                  max: 50,
                                  message: `${checkerStatusLabel.COMMENT} cannot exceed 50 characters.`
                                }
                              ]}
                            >
                              <TextArea
                                autoSize={{minRows: 2, maxRows: 4}}
                                placeholder="Enter Comment"
                                maxLength={100}
                                onChange={(e) => {
                                  setFieldsValue({
                                    [checkerStatusKey.COMMENT]: e.target.value
                                  });
                                }}
                              />
                            </Form.Item>
                          </Flex>
                        ) : (
                          'N/A'
                        )
                      ) : (
                        <>
                          {item?.isGreen ? (
                            <PilComp value={renderValue} color={color} />
                          ) : (
                            <div>{renderValue}</div>
                          )}
                        </>
                      )}
                    </Col>
                  </>
                )}
              </Row>
            )}
          </Fragment>
        );
      })}
    </Flex>
  );
};

export default AllDataInfo;
